<div *ngIf="_loadingBanks" class="spinner-container d-flex justify-content-center align-items-center w-100">
    <mat-spinner></mat-spinner>
</div>

<section class="page d-flex flex-column h-100">
  
    <ng-container *ngIf="!_loadingBanks && banks.length > 0">
  
      <div class="px-3 pt-3">
        <button matSuffix mat-icon-button (click)="back()" class="mb-3">
          <mat-icon>arrow_back</mat-icon>
        </button>
  
        <h2 translate>title.select_your_bank</h2>
  
        <mat-form-field class="w-100">
          <mat-icon matPrefix>search</mat-icon>
          <input [(ngModel)]="search" name="search" matInput type="text"
            [placeholder]="'actions.search' | translate" autocomplete="off" />
          <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="search=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
  
      <div class="flex-grow-1 overflow-auto px-3" style="min-height: 0;">
        <div class="border rounded p-4">
  
          <mat-list-item *ngIf="!search" class="px-0">
            <span class="list-title" translate>title.most_used_banks</span>
          </mat-list-item>
  
          <mat-list *ngIf="!search" role="list" class="p-0">
            <mat-list-item *ngFor="let bank of mostUsedBanks; let i = index" (click)="select(bank)"
              [class]="((i !== mostUsedBanks.length - 1) ? 'border-bottom' : '') + ' px-0'" matRipple>
              <div class="d-flex justify-content-between">
                <span class="d-block text-truncate">{{ bank.name }}</span>
                <mat-icon color="primary">chevron_right</mat-icon>
              </div>
            </mat-list-item>
          </mat-list>
  
          <mat-list-item *ngIf="!search" class="px-0 pt-3">
            <span class="list-title" translate>title.az</span>
          </mat-list-item>
  
          <mat-list role="list" class="p-0">
            <mat-list-item *ngFor="let bank of filteredBanks; let i = index" (click)="select(bank)"
              [class]="((i !== filteredBanks.length - 1) ? 'border-bottom' : '') + ' px-0'" matRipple>
              <div class="d-flex justify-content-between">
                <span class="d-block text-truncate">{{ bank.name }}</span>
                <mat-icon color="primary">chevron_right</mat-icon>
              </div>
            </mat-list-item>
  
            <mat-list-item (click)="openBankNotListedModal()" class="border-bottom border-top px-0" matRipple>
              <div class="d-flex justify-content-between w-100">
                <span class="d-block text-truncate text-primary">
                  {{ "title.select_your_bank_not_registered" | translate }}
                </span>
                <mat-icon color="primary">chevron_right</mat-icon>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
      </div>
  
      <ng-template #bankNotListedDialog>
        <div class="p-4" style="min-width: 300px; max-width: 100%; border-radius: 12px;">
          <h2 class="mb-3" translate>title.select_your_bank_not_registered</h2>
      
          <mat-dialog-content class="mb-4 text-secondary">
            <p translate>title.select_your_bank_not_registered_description</p>
          </mat-dialog-content>
      
          <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close color="basic">
              {{ "actions.cancel" | translate }}
            </button>
            <button mat-flat-button color="primary" (click)="confirmBankNotListed()">
              {{ "actions.accept" | translate }}
            </button>
          </mat-dialog-actions>
        </div>
      </ng-template>
      
      <div class="px-3 py-3">
        <powered-by />
      </div>
  
    </ng-container>
  
  </section>
  